import React, { useState, useEffect, useRef, useContext, useMemo } from 'react'
import Col from '../../UIcomponent/Column'
import './AvaiScheduleMobile.scss'
import DateTime from '../../Utility/Method/DateTime'
import nextIcon from '../../Assets/icon/nextIcon.png'
import previousIcon from '../../Assets/icon/previousIcon.png'
import Image from '../../UIcomponent/Image'
import moment from 'moment-jalaali';
import LocalContext from '../../Context/LocalContetxt'
import closeIcon from '../../Assets/icon/closeIcon.png'
import { ThemeContext } from 'styled-components'
import LocalBooking from '../../Utility/Method/LocalBooking'
import { StatusObj } from '../CalendarSchedule/Utility/StatusObj'
import LocalAppConfig from '../../Utility/Method/LocalAppConfig'
// import IDGenerator from '../CalendarSchedule/Method/IDGenerator'
const AvaiScheduleMobile = (props) => {
    const lang = useContext(LocalContext).lang
    // const { SessionCount, Slot, State, setState , role} = props
    const { localSave, Data, SessionCount, Slot, onNextWeek, onPreviousWeek, loading, Loader, onSelect, onDeselect, onRemove, role } = props
    const [DateStatus, setDateStatus] = useState([])
    const [DailyCell, setDailyCell] = useState([])
    const appConfig = LocalAppConfig.Get()
    const MinimumBookingIntervalInMinute = Number(appConfig.MinimumBookingIntervalInMinute / 60) || 0
    // const MinimumBookingIntervalInMinute = 1
    const theme = useContext(ThemeContext)
    const DropRef = useRef();
    let localBook = localSave === true ? LocalBooking.Get() : null
    let step = props.duration || 0.5;
    let now = new Date(Date.now() + (MinimumBookingIntervalInMinute) * 60 * 60 * 1000);
    let todayYear = Number(now.getFullYear(now));
    let todayMonth = Number(now.getMonth(now));
    let todayDate = Number(now.getDate(now));
    const WeekDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const PersianMonth = [
        'فروردین',
        'اردیبهشت',
        'خرداد',
        'تیر',
        'مرداد',
        'شهریور',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند',
    ]
    const [selectedDayID, setSelectedDayID] = useState('01')
    const [firstDay, setFirstDay] = useState({
        Day: todayDate,
        Month: todayMonth,
        Year: todayYear
    })
    const [showDropdown, setShowDropdown] = useState(false)
    // let row = props.row || 6;
    let chunk = 24 / step;
    let allDay =
        [
            {
                id: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)).valueOf(),
                // id: IDGenerator.DateTimeIndexFormat(0, firstDay, step),
                INDEX: 0,
                Start: 0,
                End: step,
                startHour: 0,
                startMin: 0,
                endHour: Math.floor(step),
                endMin: step % 1 !== 0 ? 30 : 0,
                date: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)),
                date_time: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)).format('YYYY-MM-DDTHH:mm:ssZ'),
                status: 0
            }
        ];
    let Week = [];
    let acceptedTimes
    let DateStatusInBook = DateStatus.filter(each => each.status === 3)
    let leftChoise = SessionCount - DateStatusInBook.length
    // const CellGenerator = () => {
    for (let i = 1; i < 7 * (24 / step); i++) {
        allDay.push({
            id: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, i * step * 60, 0)).valueOf(),
            // id: IDGenerator.DateTimeIndexFormat(i, firstDay, step),
            INDEX: i,
            Start: allDay[i - 1].End,
            End: allDay[i - 1].End + step,
            startHour: allDay[i - 1].End < 24 ? Math.floor(allDay[i - 1].End) : Math.floor(allDay[i - 1].End) % 24,
            startMin: (allDay[i - 1].End) % 1 !== 0 ? 30 : 0,
            endHour: allDay[i - 1].End < 24 ? Math.floor(allDay[i - 1].End + step) : Math.floor(allDay[i - 1].End + step) % 24,
            endMin: (allDay[i - 1].End + step) % 1 !== 0 ? 30 : 0,
            date: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, i * step * 60, 0)),
            date_time: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, i * step * 60, 0)).format('YYYY-MM-DDTHH:mm:ssZ'),
            status: 0
        })
    };
    // }
    // setTimeout(CellGenerator(), 0)
    let startIndex
    let endIndex
    // let monthLength = new Date(todayYear, (todayMonth + 1 || 0), 0).getDate()
    let startKey = moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day)).valueOf()
    let endKey = startKey + 7 * 24 * 60 * 60 * 1000
    DateStatus && DateStatus.map((avai, i) => {
        let monthLength = new Date(todayYear, (todayMonth + 1 || 0), 0).getDate()
        let avaiFromDate = Number(moment(avai.date_time_from).format('D'))
        let avaiFromHour = Number(moment(avai.date_time_from).format('H'))
        let avaiFromMinute = Number(moment(avai.date_time_from).format('mm'))
        let avaiToDate = Number(moment(avai.date_time_to).format('D'))
        let avaiToMonth = Number(moment(avai.date_time_to).format('M') - 1)
        let avaiToHour = Number(moment(avai.date_time_to).format('H'))
        let avaiToMinute = Number(moment(avai.date_time_to).format('mm'))
        let fromColumnIndex
        let toColumnIndex
        let SlotMonthDate = moment(avai.date_time_to).format('MMDD')
        let MonthPlus = firstDay.Month + 1
        let fistDayMonthStr = `${MonthPlus < 10 ? '0' + MonthPlus : MonthPlus}${firstDay.Day < 10 ? '0' + firstDay.Day : firstDay.Day}`
        if (SlotMonthDate >= fistDayMonthStr) {
            if (avaiToMonth !== firstDay.Month) {
                toColumnIndex = Math.abs((avaiToDate + monthLength) - firstDay.Day)
                fromColumnIndex = Math.abs((avaiFromDate + monthLength) - firstDay.Day)
            }
            else {
                toColumnIndex = Math.abs(avaiToDate - firstDay.Day)
                fromColumnIndex = Math.abs(avaiFromDate - firstDay.Day)

            }
        }
        let fromRowIndex
        let toRowIndex
        fromRowIndex = (avaiFromHour / step)
        toRowIndex = (avaiToHour / step)
        if (avaiFromMinute === 30) {
            fromRowIndex = (avaiFromHour / step) + 1
        }
        if (avaiToMinute === 30) {
            toRowIndex = (avaiToHour / step) + 1
        }
        startIndex = Number(fromColumnIndex * 48 + fromRowIndex)
        endIndex = Number(toColumnIndex * 48 + toRowIndex)
        // for (let x = startIndex; x < endIndex; x++) {
        //     if (allDay[x]) {
        //         allDay[x].key = avai.key
        //         allDay[x].status = avai.status
        //     }
        // }
        if (isNaN(startIndex) === false && isNaN(endIndex) === false) {
            if (avai.id === undefined) {
                for (let x = startIndex; x < endIndex; x++) {
                    if (allDay[x]) {
                        allDay[x].status = avai.status
                        if (x === endIndex - 1 && avai.status === 1) {
                            allDay[x].status = avai.status
                        }
                    }
                }
            }
            else {
                if (startKey <= avai.id && avai.id <= endKey) {
                    for (let j = avai.INDEX; j < avai.INDEX + Slot; j++) {
                        allDay[j].id = avai.id
                        allDay[j].status = avai.status
                    }
                }
            }
        }
    })

    for (let j = 0; j < allDay.length; j += chunk) {
        Week.push({
            day: WeekDay[moment(allDay[j].date_time).day()],
            date_time: {
                day: Number(moment(allDay[j].date_time).format('jDD')),
                month: Number(moment(allDay[j].date_time).format('jMM')),
                year: Number(moment(allDay[j].date_time).format('jYYYY'))
            },
            times: allDay.slice(j, j + chunk)
        })
    }
    // useMemo(() => {
    // return (
    // const newDailyCellGenerator = () => {
    //     return (
    let newWeek = Week.map((each, index) => {
        acceptedTimes = each.times.filter((time, i) =>
            (time.status === 1 || time.status === 3)
            &&
            each.times[i + Slot - 1] &&
            (each.times[i + Slot - 1].status === 1 || each.times[i + Slot - 1].status === 3)
        )
        let newTimes = acceptedTimes.map((Each, I) => {
            // let date_time_to = each.times[each.times.findIndex(item => item === Each) + Slot].date_time
            return (
                {
                    ...Each,
                    BStatus: Each.status,
                    date_time_from: Each.date_time,
                    // date_time_to,
                }
            )
        })
        for (let i = 0; i < newTimes.length; i++) {
            if (i < newTimes.length - 1) {
                for (let j = i + 1; j < i + Slot; j++) {
                    if ((newTimes[i].BStatus == 3) && newTimes[i + 1].INDEX - newTimes[i].INDEX === 1) {
                        newTimes[j].BStatus = SessionCount === 1 ? 1 : 2
                    }
                }
            }
            if (i > 0) {
                for (let j = i - Slot + 1; j < i; j++) {
                    if ((newTimes[i].BStatus === 3) && newTimes[i].INDEX - newTimes[j].INDEX === 1) {
                        newTimes[j].BStatus = SessionCount === 1 ? 1 : 2
                    }
                }
            }
        }
        return (
            {
                ...each,
                ID: `${index}` + `${index + 1}`,
                hasAvaialability: acceptedTimes.length == 0 ? false : true,
                times: newTimes
            }
        )

    }
    );
    const nextWeekHandler = (callback) => {
        let nextWeekStartEpoche = moment(new Date(firstDay.Year, (firstDay.Month), firstDay.Day)) + 7 * 24 * 60 * 60 * 1000
        let StartDay = {
            ...firstDay,
            Day: Number(moment(nextWeekStartEpoche).format('D')),
            Month: Number(moment(nextWeekStartEpoche).format('M') - 1),
            Year: Number(moment(nextWeekStartEpoche).format('YYYY'))
        };
        setFirstDay(StartDay)
        if (callback) {
            callback(StartDay)
        }
    }
    const previousWeekHandler = (callback) => {
        let nextWeekStartEpoche = moment(new Date(firstDay.Year, (firstDay.Month), firstDay.Day)) - 7 * 24 * 60 * 60 * 1000
        let StartDay = {
            ...firstDay,
            Day: Number(moment(nextWeekStartEpoche).format('D')),
            Month: Number(moment(nextWeekStartEpoche).format('M') - 1),
            Year: Number(moment(nextWeekStartEpoche).format('YYYY'))
        };
        setFirstDay(StartDay)
        if (callback) {
            callback(StartDay)
        }
    }
    const setSelectedTimes = (Day) => {
        setSelectedDayID(Day.ID)
    }
    const CellClickHandler = (cell, index, leftChoise, selectCallback, deselectCallback) => {
        if (cell.BStatus === 1) {
            let newDateStatus = [...DateStatus];
            let CellDateTime = {
                Year: Number(moment(allDay[index][`date_time`]).format('YYYY')),
                Month: Number(moment(allDay[index][`date_time`]).format('MM')),
                Day: Number(moment(allDay[index][`date_time`]).format('DD')),
                Hour: Number(moment(allDay[index][`date_time`]).format('HH')),
                Min: Number(moment(allDay[index][`date_time`]).format('mm')),
            }
            let nextCellDateTime = moment(new Date(CellDateTime.Year, CellDateTime.Month - 1, CellDateTime.Day, CellDateTime.Hour, CellDateTime.Min + Slot * 30, 0)).format('YYYY-MM-DDTHH:mm:ssZ')
            let newDateObj = {
                id: cell.id,
                INDEX: index,
                date_time_from: cell[`date_time`],
                date_time_to: nextCellDateTime,
                status: 3
            }
            if (DateStatus.filter(each => each.status === 3).length < SessionCount && SessionCount > 1 && localBook) {
                if (!newDateStatus.includes(cell)) {
                    newDateStatus.push(newDateObj)
                    setDateStatus(newDateStatus)
                    if (localSave === true) {
                        localBook.TimeSlots.push(newDateObj)
                        LocalBooking.Set(localBook)
                    }
                    selectCallback(newDateStatus)
                    // if (callback) {
                    //     callback()
                    // }
                }
            }
            else if (SessionCount == 1) {

                newDateStatus = newDateStatus.filter(each => !each.id)
                newDateStatus.push(newDateObj)
                setDateStatus(newDateStatus)
                if (localSave === true) {
                    localBook.TimeSlots = []
                    localBook.TimeSlots.push(newDateObj)
                    LocalBooking.Set(localBook)
                }
                selectCallback(newDateStatus)
                // if (callback) {
                //     callback()
                // }
            } else {
                return null
            }
        } else if (cell.BStatus === 3) {
            let newDateStatus = [...DateStatus]
            let CellIndex = newDateStatus.findIndex(each => each.id === cell.id)
            allDay[cell.INDEX].status = StatusObj.Available
            newDateStatus.splice(CellIndex, 1)
            setDateStatus(newDateStatus)
            if (localSave === true) {
                let localIndex = localBook.TimeSlots.findIndex(each => each.id === cell.id)
                localBook.TimeSlots.splice(localIndex, 1)
                LocalBooking.Set(localBook)
            }
            // if (callback) {
            //     callback(leftChoise)
            // }else {
            //     return null
            // }
            deselectCallback(leftChoise)
        }

    }
    const DropdownHandler = () => {
        setShowDropdown(true)
    }
    const removeFromDropdown = (booked, leftChoise, callback) => {
        let newDateStatus = [...DateStatus]
        let bookedIndex = newDateStatus.findIndex(each => each === booked);
        newDateStatus.splice(bookedIndex, 1)
        setDateStatus(newDateStatus)
        // BookingCtxt.setWeeklyCell(Week)
        let newTimeSlot
        if (localSave === true) {

            if (localBook) {
                newTimeSlot = localBook.TimeSlots.filter(each => each.id !== booked.id)
                localBook.TimeSlots = newTimeSlot
            }
            LocalBooking.Set(localBook)
        }
        if (callback) {
            callback(leftChoise)
        }
    }
    const DropOutSideClick = (e) => {
        if (DropRef && DropRef.current) {
            if (!DropRef.current.contains(e.target)) {
                setShowDropdown(false)
            }
        }
    }

    useMemo(() => {
        // setDailyCell(newWeek)
        setDateStatus(Data)
    }, [Data])
    useEffect(() => {
        setDailyCell(newWeek)
        window.addEventListener('mousedown', DropOutSideClick, false)
        return (() => {
            window.removeEventListener('mousedown', DropOutSideClick, false)
        });
    }, [DateStatus])
    let currentMonth = [...new Set([...Week.map(each => { return each.date_time.month })])]
    let currentMonthYear = [...new Set([...Week.map(each => { return each.date_time.year })])].reverse()
    let currentMonthStr = () => {
        let str = ''
        let CurrentMonthArr = []
        currentMonth.forEach((each, index) => {
            CurrentMonthArr.push(PersianMonth[each - 1])
        })
        str = `${CurrentMonthArr.join(' - ')}`
        return (
            <div>
                {str}
            </div >
        )
    }
    let currentYearStr = () => {
        let str = ''
        let CurrentYearArr = []
        currentMonthYear.forEach((each, index) => {
            if (index !== currentMonthYear.length - 1 && currentMonthYear.length > 1) {
                let eachStr = each.toString()
                CurrentYearArr.push(`${eachStr[2] + '' + eachStr[3]}`)
            } else {
                CurrentYearArr.push(each)
            }
        })
        str = `${CurrentYearArr.join(' - ')}`
        return (
            <div>
                {str}
            </div >
        )
    }
    let ButtonDisable = firstDay.Month === todayMonth && firstDay.Day - todayDate < 7

    return (
        <Col
            className='l__AvaiScheduleMobile'
            xl={24} lg={24} md={24} sm={24} xs={24}
        >

            <Col
                xs={23} sm={23}
                className='c__AvaiScheduleMobile__Action'
            >
                {role === 'Teacher' &&

                    <Col
                        xl={15} lg={12} md={15} sm={24} xs={24}
                        className='o__AvailabiltySchedule__Notif'
                    >
                        <Col
                            style={{
                                color: theme.danger,
                                fontWeight: 800,
                                backgroundColor: theme.danger,
                                padding: '5px 15px 5px 15px',
                                borderRadius: '7px',
                                color: 'white',
                                fontSize: theme.fontSizeSm,
                                margin: '10px'
                            }}
                        >
                            شما به عنوان استاد در سایت وارد شده اید و امکان رزرو کلاس ندارید
                            </Col>
                    </Col>
                }
                <Col
                    xl={20} lg={20}
                    onClick={DropdownHandler}
                    className='c__AvaiScheduleMobile__SessionController'
                >
                    {
                        // !mini && 
                        SessionCount > 1 &&
                        <Col
                            className='o__SessionController__Dropdown'
                        >
                            {leftChoise > 0 ?
                                <Col>
                                    {`${leftChoise} جلسه برای زمان بندی باقیمانده است `}
                                </Col>
                                : 'همه جلسات انتخاب شده اند'}
                        </Col>
                    }
                    <Col
                        className='o__SessionController__Dropdown__Content'
                        innerRef={DropRef}
                        style={{
                            display: showDropdown ? 'flex' : 'none'
                        }}
                    >
                        {DateStatusInBook.length > 0 && DateStatusInBook.map((booked, index) => {
                            return (
                                <Col
                                    xl={24} lg={24} md={24} sm={24} md={24}
                                >
                                    <Col
                                        className='o__Dropdown__Content__Index'
                                        xl={4} lg={4} md={4} sm={4} md={4}
                                    >{index + 1}</Col>
                                    <Col
                                        className='o__Dropdown__Content__Detail'
                                        xl={18} lg={18} md={18} sm={18} md={18}
                                    >
                                        {DateTime.getDayFullStr(`${moment(booked.date_time_from).format('ddd')}`)[`${lang}`]
                                            + ' , ' + moment(booked.date_time_from).format('jDD') + ' ' + PersianMonth[Number(moment(booked.date_time_from).format('jMM')) - 1] + ' - ' +
                                            moment(booked.date_time_from).format('HH') + ':' + moment(booked.date_time_from).format('mm')
                                            + ' تا ' +
                                            moment(booked.date_time_to).format('HH') + ':' + moment(booked.date_time_to).format('mm')
                                        }
                                    </Col>
                                    <Col
                                        className='o__Dropdown__Content__Remove'
                                        xl={4} lg={4} md={4} sm={4} md={4}
                                    >
                                        <Image
                                            onClick={() => removeFromDropdown(booked, leftChoise, onRemove)}
                                            src={closeIcon} />
                                    </Col>
                                </Col>
                            )
                        })}
                    </Col>
                </Col>
                <Col
                    sm={24} xs={24}
                    className='c__AvaiScheduleMobile__WeekController'
                >
                    <Col
                        sm={4} xs={4}
                        className={`${ButtonDisable === true ? 'o__WeekController__Button--OFF' : 'o__WeekController__Button'}`}
                        onClick={ButtonDisable === false ? () => previousWeekHandler(onPreviousWeek) : null}

                    >
                        <Col
                        >
                            <Image src={nextIcon} />
                        </Col>
                    </Col>
                    <Col
                        sm={16} xs={16}
                        className='o__WeekController__CurrentMonth'
                    >
                        {
                            currentMonthStr()
                        }
                        {
                            currentYearStr()
                        }
                    </Col>

                    <Col
                        sm={4} xs={4}
                        className='o__WeekController__Button'
                    >
                        <Col
                            onClick={() => nextWeekHandler(onNextWeek)}
                        >
                            <Image
                                src={previousIcon} />
                        </Col>
                    </Col>
                </Col>
            </Col>
            <Col
                xl={24} lg={24} md={24} sm={23} xs={23}
                className='c__AvaiScheduleMobile__TopBar'
            >
                <Col
                    className='c__AvaiScheduleMobile__Day'
                    xl={16} lg={16} md={21} sm={21} xs={23}
                >
                    {DailyCell.length > 0 && DailyCell.map(day => {

                        return (
                            <Col
                                xl={24 / 7}
                                lg={24 / 7}
                                md={24 / 7}
                                sm={24 / 7}
                                xs={24 / 7}
                                className='o__AvaiScheduleMobile__Day'
                            >
                                <Col
                                    className={day.hasAvaialability === false && 'o__AvaiScheduleMobile__Day--Disable'}
                                >
                                    {DateTime.getDayFullStr(day.day)[`${props.lang}`]}
                                </Col>
                                <Col
                                    onClick={() => setSelectedTimes(day)}
                                    className={day.hasAvaialability === false && 'o__AvaiScheduleMobile__Day--Disable'
                                    }
                                >
                                    <Col
                                        className={
                                            day.ID === selectedDayID && 'o__AvaiScheduleMobile__Day--Selected'
                                        }
                                    >
                                        {day.date_time.day}

                                    </Col>
                                </Col>
                            </Col>
                        )
                    })}
                </Col>
            </Col>
            <Col
                className='c__AvaiScheduleMobile__AvaiTimes'
                sm={23} xs={23}
            >
                {/* <span></span> */}
                <Col
                    className='c__AvaiScheduleMobile__Title'
                    sm={24} xs={24}
                >
                    ساعت
                    </Col>
                <span></span>
                <Col
                    className='c__AvaiScheduleMobile__Times'
                    style={{
                        justifyContent:
                            DailyCell.filter(each => each.ID == selectedDayID)[0] &&
                            DailyCell.filter(each => each.ID == selectedDayID)[0].times.length == 0 && 'center'
                    }}
                    sm={24} xs={24}
                >
                    {DailyCell.length == 0 || loading == true ?
                        <Col
                            className='c__AvaiScheduleMobile__Times__Loader'
                            sm={24} xs={24}
                        >
                            <Loader height={100} />
                        </Col>
                        :
                        DailyCell.filter(each => each.ID == selectedDayID)[0].times.length > 0 ?
                            DailyCell.filter(each => each.ID == selectedDayID)[0].times.map(time => {
                                return (
                                    <Col
                                        sm={time.BStatus === 3 ? 12 : 6} xs={time.BStatus === 3 ? 12 : 6}
                                        className='o__AvaiScheduleMobile__Times'
                                        style={{
                                            display: time.BStatus === 2 && 'none'
                                        }}
                                    >
                                        <Col
                                            className={time.BStatus === 3 ? 'o__AvaiScheduleMobile__Times--Booked' :
                                                time.BStatus === 2 ? 'o__AvaiScheduleMobile__Times--Deactive' : null}
                                            onClick={() => CellClickHandler(time, time.INDEX, leftChoise, onSelect, onDeselect)}
                                        >
                                            {time.BStatus === 3 ?
                                                (time.startHour < 10 ? '0' + time.startHour : time.startHour) + ':' +
                                                (time.startMin === 0 ? '00' : time.startMin) + ' تا ' +
                                                (allDay[time.INDEX + Slot].startHour < 10 ? '0' + allDay[time.INDEX + Slot].startHour : allDay[time.INDEX + Slot].startHour) + ':' +
                                                (allDay[time.INDEX + Slot].startMin === 0 ? '00' : allDay[time.INDEX + Slot].startMin) :
                                                (time.startHour < 10 ? '0' + time.startHour : time.startHour) + ':' +
                                                (time.startMin === 0 ? '00' : time.startMin)}
                                        </Col>
                                    </Col>
                                )
                            }) :
                            <Col
                                sm={20} xs={20}
                                style={{
                                    fontSize: theme.fontSizeMd,
                                    alignSelf: 'center',
                                    backgroundColor: theme.warning,
                                    borderRadius: '7px',
                                    color: theme.white,
                                    marginTop: '25px',
                                    height: '40px'
                                }}
                            >
                                {`برای روز انتخاب شده زمان آزاد وجود ندارد`}
                            </Col>
                    }
                </Col>
            </Col>
        </Col >
    )
    // }, [showDropdown, selectedDayID , DailyCell ])
}
export default AvaiScheduleMobile
